import React from "react";
import styles from "./styles.module.scss";

const MedicalCouponCare = ({ care247Available }) => {
  return (
    <>
      <div className={styles.MedicalCouponCare}>
        <div dangerouslySetInnerHTML={{ __html: care247Available?.header }} />
        <div dangerouslySetInnerHTML={{ __html: care247Available?.content }} />
        <div dangerouslySetInnerHTML={{ __html: care247Available?.footer }} />
      </div>
    </>
  );
};

export default MedicalCouponCare;
